import { render, staticRenderFns } from "./AnalyticsTotals.vue?vue&type=template&id=0a8327f1&scoped=true&"
import script from "./AnalyticsTotals.vue?vue&type=script&lang=js&"
export * from "./AnalyticsTotals.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsTotals.vue?vue&type=style&index=0&id=0a8327f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8327f1",
  null
  
)

export default component.exports